import { isMobilePattern } from '../../../libs/utils'
import useForm from './useForm'

export default function useLoginForm(config) {
  const { initialState = {}, errorMessages = {} } = config
  const { errors, inputs, submitted, setSubmitted, onSubmit, onChange } =
    useForm({
      initialState: {
        username: initialState.username || '',
        password: initialState.password || '',
      },
      validate(data) {
        const { username, password } = data
        const newErrors = {}
        if (username.length === 0) {
          newErrors.username = errorMessages.NO_USERNAME || '請輸入手機號碼'
        } else if (!isMobilePattern(username)) {
          newErrors.username =
            errorMessages.USERNAME_FORMAT_INVALID || '格式錯誤，請輸入手機號碼'
        }
        if (!config.skipValidatePassword) {
          if (password.length === 0) {
            newErrors.password = errorMessages.NO_PASSWORD || '請輸入密碼'
          } else if (password.length < 8) {
            newErrors.password =
              errorMessages.SHORT_PASSWORD || '密碼需至少 8 個字元'
          }
        }
        return newErrors
      },
      onSuccessSubmit: config.onSuccessSubmit,
    })

  return {
    errors,
    inputs,
    submitted,
    setSubmitted,
    onSubmit,
    onChange,
  }
}
